import { getMessageList, getmessageDetail } from '../services';
import { parse } from 'qs';

export default {
  namespace: 'noticeMessage',
  state: {
    messageList: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0, 
    },
    detail: {},
    visible: false,
  },
  effects: {
    *getMessageList({ payload }, { call, put }) {
      const res = yield call(getMessageList, payload);
      const { data = [], total = 0 } = res;
      yield put({
        type: 'update',
        payload: {
          messageList: data || [], 
          pagination: {
            current: payload.pageNo,
            pageSize: payload.pageSize,
            total,
          },
        },
      });
      return res;
    },
    *fetchDetail({ payload }, { call, put }) {
      const res = yield call(getmessageDetail, payload);
      yield put({
        type: 'update',
        payload: {
          detail: res, 
          visible: true,
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    // 监听地址，如果地址含有app则跳转到登陆页
    setup({ dispatch, history }) {
      history.listen((location) => {
        const { hash } = location;
        const data = parse(hash.replace('#', ''));
        
        if (hash.indexOf('popVisible') >= 0 && hash.indexOf('popType') >= 0 && hash.indexOf('popId') >= 0) {
          dispatch({
            type: 'fetchDetail',
            payload: { mid: data.popId },
          });
        }
      });
    },
  },
};
